import axios from "axios";

const sbomBaseUrl = process.env.REACT_APP_API_URL;

const SbomApiInstance = axios.create({
    baseURL: sbomBaseUrl || '',
});

let sbomRefreshToken = null;

SbomApiInstance.interceptors.request.use(
    async (req) => {
        const token = sessionStorage.getItem('access_token');

        req.headers = {
            ...req.headers,
            'Authorization': 'Basic YmFzZWFkbWluOmRlZmF1bHRANDU2',
            'ngrok-skip-browser-warning': true,
        };

        if (token) {
            req.headers['token'] = `Bearer ${token}`;
        }
        return req;
    },
    (error) => Promise.reject(error)
);

SbomApiInstance.interceptors.response.use(
    async (response) => {
        const body = response?.data;
        // Store refresh token if provided by the backend
        if (body?.response_data?.data?.refresh_token) {
            sbomRefreshToken = body.response_data.data.refresh_token;
        }

        const innerCode = body?.error?.error_code;
        const innerMsg = (body?.error?.message || '').toLowerCase();
        const tokenInvalid = body?.status === 0
            && (innerCode === 403 || innerCode === 401)
            && (innerMsg.includes('invalid') || innerMsg.includes('expired') || innerMsg.includes('token'))
            && !response.config?._retried;

        if (tokenInvalid) {
            // Try refresh token if available
            if (sbomRefreshToken) {
                try {
                    const refreshRes = await axios.post(
                        `${sbomBaseUrl}auth/refresh/`,
                        { refresh_token: sbomRefreshToken },
                        { headers: { 'Content-Type': 'application/json', 'Authorization': 'Basic YmFzZWFkbWluOmRlZmF1bHRANDU2' } }
                    );
                    const newToken = refreshRes?.data?.response_data?.data?.access_token;
                    if (newToken) {
                        try { sessionStorage.setItem('access_token', newToken); } catch (e) {}
                        if (refreshRes?.data?.response_data?.data?.refresh_token) {
                            sbomRefreshToken = refreshRes.data.response_data.data.refresh_token;
                        }
                        response.config._retried = true;
                        response.config.headers['token'] = `Bearer ${newToken}`;
                        return SbomApiInstance(response.config);
                    }
                } catch (refreshErr) {}
            }
            // Refresh failed — clear session so the user goes back to login
            try { sessionStorage.removeItem('access_token'); } catch (e) {}
        }
        return { statusCode: body, errors: body?.error };
    },
    async (error) => {
        const errorCode = error?.response?.data?.error?.error_code;
        if ((errorCode === 403 || errorCode === 401) && sbomRefreshToken && !error.config?._retried) {
            try {
                const refreshRes = await axios.post(
                    `${sbomBaseUrl}auth/refresh/`,
                    { refresh_token: sbomRefreshToken },
                    { headers: { 'Content-Type': 'application/json', 'Authorization': 'Basic YmFzZWFkbWluOmRlZmF1bHRANDU2' } }
                );
                const newToken = refreshRes?.data?.response_data?.data?.access_token;
                if (newToken) {
                    try { sessionStorage.setItem('access_token', newToken); } catch (e) {}
                    if (refreshRes?.data?.response_data?.data?.refresh_token) {
                        sbomRefreshToken = refreshRes.data.response_data.data.refresh_token;
                    }
                    error.config._retried = true;
                    error.config.headers['token'] = `Bearer ${newToken}`;
                    return SbomApiInstance(error.config);
                }
            } catch (refreshErr) {}
        }
        // Deployment in progress — gateway 5xx only. Bare network errors
        // (no response) are NOT treated as deploys, otherwise a brief
        // offline blip would log the user out.
        const status = error?.response?.status;
        if (status === 502 || status === 503 || status === 504) {
            window.dispatchEvent(new Event('maintenance_mode'));
        }
        return Promise.reject(error);
    }
);

export default SbomApiInstance;
